import {  useMemo, useState } from 'react'
import placeholder from '../../../../assets/placeholder_artist.jpg';
import { Box, Button, Chip, Skeleton, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom';
import styles from './InterpretorsFocus.module.css'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import PlayTopTracksButton from '../../../utils/PlayTopTracksButton';
import AlbumIcon from '@mui/icons-material/Album';

var buttonStyle = {color: '#fff', p: 1, minWidth: '16px', borderRadius: '32px'}
var buttonsContainerStyle = {backgroundColor: '#000000D0', p: 1, m: 1, borderRadius: '32px', height: '32px', position: 'absolute', bottom: 0, pointerEvents: 'all'}
var rankChipStyle = {fontWeight: 900, fontSize: '1rem'}
var artistNameStyle = {pointerEvents: 'all', color: '#fff', padding: '1rem', m: 1, fontWeight: '700', fontSize: '1.4rem', backgroundColor: '#000000D0',  borderRadius: '16px', '& a' : { textDecoration: 'none'}}


interface InterpretorsFocusProps {
    discoverData: any
}

const InterpretorsFocus = ({discoverData}: InterpretorsFocusProps) => {
    var [currentIndex, setCurrentIndex] = useState(0) 

    const interpretors = useMemo(() => {
        if (discoverData === null)
            return []

        let dayRanks = discoverData?.rankings
        var artists_ids: any = []
        var allProducers: any = []
        for (const rank of dayRanks) {
            if (rank.track.main_artists && rank.track.main_artists.length > 0) {
                rank.track.main_artists.map((producer: any) => {
                    if (![...allProducers].map((prod: any) => prod._id).includes(producer._id)) 
                        allProducers.push(producer)
                    artists_ids[producer._id] = (artists_ids[producer._id] || 0) + 1
                    return producer
                })
            }
        }

        var items = Object.keys(artists_ids).map(function(key) { return [key, artists_ids[key]] })
        items.sort(function(a, b) { return b[1] - a[1] })

        setCurrentIndex(0)
        return allProducers.sort((a: any, b: any) => items.map((item: any) => item[0]).indexOf(a._id) - items.map((item: any) => item[0]).indexOf(b._id)).map((prod: any, i: number) => {
            return {
                ...prod,
                topTrackCount: items[i][1]
            }
        })
    }, [discoverData])
    
    const showNextArtist = () => {
        if (currentIndex + 1 === interpretors.length || currentIndex > interpretors.length) {
            setCurrentIndex(0)
        } else {
            setCurrentIndex(currentIndex + 1)
        }
    }

    const showPreviousArtist = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            setCurrentIndex(interpretors.length - 1)
        } else {
            setCurrentIndex(currentIndex - 1)
        }
    }


    return interpretors && interpretors.length > 0
    ?   
        <Box className={styles.interpretorItem} sx={{minHeight: '30%', width: '100%'}}>
            <Stack className={styles.interpretorInfos}>

                <Stack direction={'row'} alignItems={'center'}>
                    <Typography sx={artistNameStyle} ><Link to={`/artist/${interpretors[currentIndex]?._id}`}>{ interpretors[currentIndex]?.artist_name }</Link></Typography>
                </Stack>

                <Stack direction={'row'} sx={{position: 'absolute', bottom: 0, p: 1, m: 1, mr: 0, backgroundColor: '#000000D0', borderRadius: '32px', height: '32px'}} alignItems={'center'}>
                    <Chip color={'secondary'} key={currentIndex} label={'#'+ (currentIndex+1)} sx={rankChipStyle}/>
                    <Stack direction={'row'} alignItems={'center'} sx={{mr: 1, display: {xs: 'none', md: 'flex', lg: 'flex'},}}>
                        <AlbumIcon sx={{fontSize: '1.2rem', m: 1}}  />
                        <Typography sx={{color: '#fff', fontWeight: 700, fontSize: '1.2rem'}} >{ interpretors[currentIndex]?.topTrackCount }</Typography>
                    </Stack> 
                </Stack>

                <Stack direction={'row'} sx={{position: 'absolute', bottom: 0, right: 0, p: 1, m: 1, backgroundColor: '#000000D0', borderRadius: '32px', height: '32px', display: {xs: 'flex', md: 'none', lg: 'none'}}} alignItems={'center'}>
                    <Stack direction={'row'} alignItems={'center'} sx={{mr: 1}}>
                        <AlbumIcon sx={{fontSize: '1.2rem', m: 1}}  />
                        <Typography sx={{color: '#fff', fontWeight: 700, fontSize: '1.2rem'}} >{ interpretors[currentIndex]?.topTrackCount }</Typography>
                    </Stack> 
                </Stack>
                
                <Stack direction={'row'} alignSelf={{xs: 'center'}} sx={buttonsContainerStyle}>
                    <Button onClick={() => showPreviousArtist()} sx={buttonStyle}><NavigateBeforeIcon /></Button>
                    <PlayTopTracksButton artistId={interpretors[currentIndex]?._id} style={buttonStyle} />
                    <Button onClick={() => showNextArtist()} sx={buttonStyle} ><NavigateNextIcon /></Button>
                </Stack>

            </Stack>

            <Link to={`/artist/${interpretors[currentIndex]?._id}`}>
                <img 
                    height='100%' 
                    width='100%' 
                    className="image-cover" 
                    src={interpretors && interpretors[currentIndex]?.avatar_url ? interpretors[currentIndex]?.avatar_url.replace("cw.png","cc.png").replace("{w}","800").replace("{h}","600") : placeholder} 
                    alt={interpretors ? interpretors[currentIndex]?.artist_name : ''} />
            </Link>
        </Box>
    :   
        <Skeleton variant="rectangular" width={'50%'} height={'100%'} sx={{bgcolor: '#000000A8'}} />
}

export default InterpretorsFocus